class AuthAPI {
	constructor(apiCall) {
		this.apiCall = apiCall;
	}

	async createAccountSession(accountID) {
		try {
			const result = await this.apiCall.post('/agency/account/session', { id: accountID });
			return [null, result];
		} catch (e) {
			return [e];
		}
	}

	async createSession(login, password) {
		try {
			const result = await this.apiCall.post('/v2/users/sign-in', { login, password });
			return [null, result.token];
		} catch (e) {
			return [e];
		}
	}

	async getSessionInfo() {
		try {
			const result = await this.apiCall.get({ gate: '/auth/session' });
			return [null, result];
		} catch (e) {
			return [e];
		}
	}

	async getNewAuthUser() {
		try {
			const result = await this.apiCall.get({
				gate: '/user/current',
			});
			return [null, result];
		} catch (err) {
			return [err, {}];
		}
	}

	async getUserCabinets() {
		try {
			const result = await this.apiCall.get({
				gate: '/v2/users/me/cabinets',
			});
			return [null, result];
		} catch (err) {
			return [err, []];
		}
	}

	async changeUserCabinetFavorite({ id, favorite }) {
		try {
			favorite
				? await this.apiCall.put(`/v2/users/me/favorites/cabinets/${id}`)
				: await this.apiCall.delete(`/v2/users/me/favorites/cabinets/${id}`);
			return [null];
		} catch (err) {
			return [err];
		}
	}

	async updateUserPassword({ password }) {
		try {
			const result = await this.apiCall.patch('/v2/users/me/password', { password });
			return [null, result];
		} catch (err) {
			return [err];
		}
	}
}

export default AuthAPI;
